var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 1.66667C5.39935 1.66667 1.66602 5.4 1.66602 10C1.66602 14.6 5.39935 18.3333 9.99935 18.3333C14.5993 18.3333 18.3327 14.6 18.3327 10C18.3327 5.4 14.5993 1.66667 9.99935 1.66667ZM9.99935 13.75C7.92435 13.75 6.24935 12.075 6.24935 10C6.24935 7.925 7.92435 6.25 9.99935 6.25C12.0743 6.25 13.7493 7.925 13.7493 10C13.7493 12.075 12.0743 13.75 9.99935 13.75ZM9.99935 9.16667C9.54102 9.16667 9.16602 9.54167 9.16602 10C9.16602 10.4583 9.54102 10.8333 9.99935 10.8333C10.4577 10.8333 10.8327 10.4583 10.8327 10C10.8327 9.54167 10.4577 9.16667 9.99935 9.16667Z",
    fill: "black",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterIcon);
export default __webpack_public_path__ + "static/media/master-icon.d097feca5adf3687e8c4bedd61a6a9c3.svg";
export { ForwardRef as ReactComponent };